import React from "react";
import InfoCard from "../info-card/info-card.component";

const ApplicationCentreLink = () => {
  return (
    <InfoCard
      title="Application Help Centre"
      description="For detailed guidance and support on how to key applications."
      linkText="Find out more"
      linkHref="/application-help-centre"
      linkClass="residential-calculator"
      colClass="col-xs-12 col-xl-3"
      noMobileMargin={true}
      tealiumEventName="Application help centre"
      tealiumCategory="content"
      tealiumAction="button"
      tealiumLabel="product information"
      tealiumPage="Home"
    />
  );
};

export default ApplicationCentreLink;
